var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29253 0.715599C8.23688 0.659539 8.1707 0.615048 8.09779 0.584686C8.02488 0.554325 7.94669 0.538694 7.86772 0.538694C7.78875 0.538694 7.71056 0.554325 7.63765 0.584686C7.56474 0.615048 7.49856 0.659539 7.44291 0.715599L4.50154 3.6515L1.56073 0.709366C1.44807 0.596649 1.29526 0.533325 1.13593 0.533325C0.976592 0.533325 0.823784 0.596649 0.711118 0.709366C0.598452 0.822083 0.535156 0.97496 0.535156 1.13437C0.535156 1.29377 0.598452 1.44665 0.711118 1.55937L3.65192 4.5015L0.712817 7.4425C0.600151 7.55522 0.536856 7.70809 0.536856 7.8675C0.536856 8.02691 0.600151 8.17978 0.712817 8.2925C0.825483 8.40522 0.978291 8.46854 1.13763 8.46854C1.29696 8.46854 1.44977 8.40522 1.56243 8.2925L4.50154 5.34583L7.44291 8.2925C7.55558 8.40522 7.70839 8.46854 7.86772 8.46854C8.02705 8.46854 8.17986 8.40522 8.29253 8.2925C8.40519 8.17978 8.46849 8.02691 8.46849 7.8675C8.46849 7.70809 8.40519 7.55522 8.29253 7.4425L5.34719 4.4998L8.29253 1.55767C8.40234 1.44505 8.46381 1.29396 8.46381 1.13663C8.46381 0.979307 8.40234 0.828212 8.29253 0.715599Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.8ebebdc226f932250af10e3a0a5baa00.svg";
export { ForwardRef as ReactComponent };